// extracted by mini-css-extract-plugin
export var container = "_cf-1";
export var cornerButtonContainer = "_cf-6";
export var disabled = "_cf-2";
export var dragActive = "_cf-3";
export var fileContainer = "_cf-5";
export var hiddenInput = "_cf-4";
export var widthContainer = "_cf-0";